export const executionProgress = {
  accessoryList: {
    uploadPictures: '上传图片',
    uploadVideo: '上传视频',
    uploadPDF: '上传PDF',
    uploadAudio: '上传音频',
    uploadAttachment: '上传附件',
    uploadError: '上传错误，仅支持{suffix}格式的文件',
    confirmDelete: '确定删除{describe}',
    copySuccess: '链接复制成功！请在浏览器打开下载',
    beenDeleted: '您访问的文件已被删除',
    noAccessories: '暂无附件',
    fileSize: '文件大小：{size}M',
    updateDay: '更新：{day}',
    share: '分享',
    download: '下载',
    delete: '删除'
  },
  completionProgressDetails: '完成进度详情',
  constructionPlan: '施工计划',
  plannedDate: '计划日期',
  completionPerson: '完成人',
  completionTime: '完成时间',
  completionDescription: '完成说明',
  constructionProgress: '施工进度',
  communityName: '小区名称',
  constructionQuantity: '施工数量',
  delayed: '已延期',
  toBeAccepted: '待验收',
  acceptanceNotPassed: '验收不通过',
  modifyPlan: '修改计划',
  planDurationCannotBeEmpty: '计划工期不能为空',
  planDurationCannotBeZeroOrLess: '计划工期不能为0或者小于0',
  durationCannotBeLessThanOneDay: '工期不能少于1天',
  plannedCompletionDateCannotBeEarlierThanPlannedStartDate: '计划完工日期不能早于计划开工日期',
  plannedStartDate: '计划开工',
  plannedCompletionDate: '计划完工',
  ownerConfirmationIsRequired: '需要业主确认',
  start: '开始',
  planDuration: '计划工期',
  excludeWeekendsAndHolidays: '扣除周末和法定节假日',
  enterPlanDuration: '请输入计划工期',
  linkCopiedSuccessfully: '链接复制成功！请在浏览器打开下载',
  noConstructionDrawingsAvailable: '暂无施工图',
  sendToProjectMembers: '发送项目成员',
  publishUpdate: '发布动态',
  completionProgress: '完成进度',
  completionProgressDescription: '完成进度说明',
  shareThisMoment: '分享这一刻的动态',
  publish: '发布',
  acceptance: '验收',
  lastAcceptanceFailed: '上一次验收未通过',
  progressDetails: '进度详情',
  statusNotStarted: '未开始',
  statusToBeConfirmed: '待确认',
  statusInProgress: '进行中',
  statusAccepted: '验收通过',
  statusFailed: '验收未通过',
  immediateAcceptance: '立即验收',
  constructionUpdates: '施工动态',
  constructionProcess: '施工流程',
  projectName: '项目名称',
  constructionDrawings: '施工图',
  uncategorized: '未分类',
  unpublished: '未发布',
  delayedNumber: '{planDelayNum}项延期',
  recheck: '重新验收',
  enterReasonForFailure: '请输入未通过的理由',
  selectPersonToShare: '未选择被分享人',
  shareSuccess: '分享成功',
  noActivity: '暂无任何动态',
  allActivityLoaded: '已加载所有动态',
  confirmDeleteActivity: '是否删除该条动态？',
  collapse: '收起',
  expand: '全文',
  pleaseSignFirst: '请先签名',
  signBelow: '请在下方签名',
  complete: '完成签名',
  resign: '重签',
  delayProgress: '延期进度',
  progressInspection: '进度验收',
  delay: '延期',
  completed: '已完成'
};
